export const VALIDATION_ERRORS = {
  MISSING_PERSONALIZE_EDIT_SCOPE: 'MISSING_PERSONALIZE_EDIT_SCOPE',
  MISSING_ASSET_WRITE_SCOPE: 'MISSING_ASSET_WRITE_SCOPE',
  MISSING_ASSET_AI_SCOPE: 'MISSING_ASSET_AI_SCOPE',
  GENERATIVE_AI_DISABLED: 'GENERATIVE_AI_DISABLED',
  NO_WRITE_SCOPE: 'NO_WRITE_SCOPE',
  STRATEGY_LIMIT_REACHED: 'STRATEGY_LIMIT_REACHED',
  STRATEGY_VARIANT_LIMIT_REACHED: 'STRATEGY_VARIANT_LIMIT_REACHED',
  ASSET_NOT_PERSONALIZABLE: 'ASSET_NOT_PERSONALIZABLE',
  UNSUPPORTED_ASSET_TYPE: 'UNSUPPORTED_ASSET_TYPE'
};